import React, { Component } from 'react'
import styled from "styled-components"
import { above, below, maxHeight } from "../style/functions"
import ReactSlick from 'react-slick'

class InstagramFeed extends Component {

	constructor() {
		super()
		this.state = {
			instagrams: []
		}
	}

	componentDidMount() {
		//update using efront.com.au/instagram

		fetch('https://api.instagram.com/v1/users/3609558623/media/recent?access_token=3609558623.4a72510.031d4b5c070f4c74b51b08304e241665')
			.then(results => {
				return results.json();
			}).then(data => {
				let instagrams = data.data.map((inst, index) => {

					if (index < 6) {

						let timestampInMilliSeconds = inst.created_time * 1000;

						let date = new Date(timestampInMilliSeconds);

						let day = (date.getDate() < 10 ? '0' : '') + date.getDate();
						let month = (date.getMonth() < 9 ? '0' : '') + (date.getMonth() + 1);
						let year = date.getFullYear();

						let formattedDate = year + " " + month + " " + day;


						return (
							<Card>
								<a href={inst.link} target="_blank" style={{ backgroundImage: "url(" + inst.images.standard_resolution.url + ")" }}> </a>
								<p>{formattedDate}</p>
								<p><span>yarrabend_</span> {inst.caption.text.substring(0, 44) + "..."}</p>
							</Card>

						)
					}
				})

				this.setState({ instagrams: instagrams });
			})


	}


	render() {
		return (
			<SocialCardWrapper>
				<div className="inside" >
					{this.state.instagrams}
				</div>
			</SocialCardWrapper>
		);
	}

}


export default InstagramFeed;

const SocialCardWrapper = styled.div`
padding-bottom: 40px;
${below.desktop`
	 width: 100%;
	 overflow-y: scroll;
`};
.inside{
   display: flex;
   justify-content: space-between;
	 ${below.tablet`
	 min-width: 1230px;
	 `};
}

`

const Card = styled.div`
   flex: 0 0 15%
   a{
	   display:block;
	   height:0px;
	   padding-bottom:100%;
	   background-size:cover;
	   background-position:center;
   }
`;



// WEBPACK FOOTER //
// ./src/components/instagram-feed.js